import { JsonObject } from 'json2typescript';
import { SimulationRetirementInterface } from '../interfaces/simulation-retirement.interface';

@JsonObject('SimulationTargetGrowModelRetirement')
export class SimulationRetirenemtModel
  implements SimulationRetirementInterface
{
  Currency?: string;
  ProfileId?: number;
  TimeHorizon?: number;
  InitialContributionAmount?: number;
  PeriodicContributionAmount?: number;
  PeriodicContributionFrequency?: string;
  WithdrawlTimeHorizon?: number;
  AnnualIncomes?: number;
  LivingStandards?: number;
  SocialSecurityIncomePerc?: number;
  Priority?: number;
  InitialDate?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
